export default __webpack_public_path__ + "static/media/Wolf Tamer's Longblade.e8092739.jpg";